import { CONTROL } from '../../../../components';
import { generateInstanceConfigItems } from '../../../utils';
var configItems = generateInstanceConfigItems([[120, 480]]);
export var EVOLUTION_CONTAINER_APPS_FREE_TIER_CONFIG = {
  ui: ['serviceAlert', ['config']],
  controls: {
    serviceAlert: {
      type: CONTROL.Alert,
      uiProps: {
        description: 'Не тарифицируется каждый месяц'
      },
      accessorKey: 'tarification'
    },
    config: {
      type: CONTROL.SelectSingle,
      accessorKey: 'config',
      items: configItems,
      defaultValue: '120 480',
      uiProps: {
        disabled: true
      },
      decoratorProps: {
        label: 'Конфигурация'
      }
    }
  }
};